export const environment = {
  production: true,
  api_scheme_host: 'https://cdn.meteomatics.swiss',
  cesium_ion_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.' +
    'eyJqdGkiOiI4M2FhYWQyNS1iZTkxLTQwMTQtOTBmMS1iODYwMDZiZjQ3NGIiLCJpZCI6MTky' +
    'Mywic2NvcGVzIjpbImFzciJdLCJhc3NldHMiOlsxLDM5NTRdLCJpYXQiOjE1ODA4MDQ0OTJ9.lzYHjK9hUOAuaI7u3LnryroDxBYxeNfsz633BoMG-UM',
  maptilerKey: 'bpEW6Wr1761k2WKmkLEt',
};
